export var NATIVE = 'NATIVE';
export var CSS = 'CSS';
export default {
  CSS: CSS,
  NATIVE: NATIVE
};